import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import useSeo from '@/hooks/useSeo';
import ContactForm from './components/ContactForm';
import { allArticles } from '@/utils/data';

const team = [
  {
    name: '陈默',
    role: '主编',
    desc: '十年娱乐媒体从业经验，负责内容方向与选题把关。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20friendly%20asian%20editor%20portrait%20with%20warm%20studio%20lighting%2C%20editorial%20headshot%2C%20neutral%20background%2C%20high%20detail&width=400&height=400&seq=team-01&orientation=squarish',
  },
  {
    name: '林小满',
    role: '影视编辑',
    desc: '专注影视行业观察，擅长深度报道与幕后访谈。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20creative%20asian%20woman%20portrait%20with%20soft%20warm%20lighting%2C%20editorial%20headshot%2C%20neutral%20background%2C%20high%20detail&width=400&height=400&seq=team-02&orientation=squarish',
  },
  {
    name: '周野',
    role: '音乐编辑',
    desc: '资深乐评人，长期关注华语与全球独立音乐现场。',
    avatar: 'https://readdy.ai/api/search-image?query=thoughtful%20asian%20man%20with%20headphones%20portrait%2C%20warm%20studio%20lighting%2C%20editorial%20headshot%2C%20neutral%20background%2C%20high%20detail&width=400&height=400&seq=team-03&orientation=squarish',
  },
  {
    name: '苏禾',
    role: '潮流编辑',
    desc: '时尚与生活方式写作者，捕捉年轻人的每一股潮流。',
    avatar: 'https://readdy.ai/api/search-image?query=stylish%20asian%20woman%20with%20modern%20outfit%20portrait%2C%20warm%20editorial%20lighting%2C%20neutral%20background%2C%20high%20detail&width=400&height=400&seq=team-04&orientation=squarish',
  },
];

const features = [
  { icon: 'ri-time-line', title: '及时更新', desc: '热点第一时间跟进，热点资讯不迟到。' },
  { icon: 'ri-stack-line', title: '内容丰富', desc: '影视、音乐、明星、潮流四大板块全覆盖。' },
  { icon: 'ri-book-open-line', title: '深度阅读', desc: '既有速览速读，也有值得细读的深度报道。' },
  { icon: 'ri-device-line', title: '多端适配', desc: '电脑与手机都能舒适浏览，随开随看。' },
];

export default function AboutPage() {
  useSeo({
    title: '关于我们 - 色哟哟多元娱乐资讯平台',
    description: '了解色哟哟的品牌定位、团队与联系方式。色哟哟致力于为用户提供及时、丰富、有态度的娱乐资讯内容。',
    keywords: '色哟哟,关于我们,娱乐资讯,团队介绍,联系方式',
  });

  return (
    <div className="w-full">
      <div className="border-b border-background-200 bg-background-100 px-4 py-6 md:px-8 md:py-8">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
      </div>

      <section className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-sparkling-fill"></i>
              关于色哟哟
            </span>
            <h1 className="mt-4 text-3xl font-bold text-foreground-950 md:text-4xl">
              让每一条娱乐资讯，都值得被认真对待
            </h1>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              色哟哟是一个多元娱乐资讯平台，聚焦影视、音乐、明星动态与潮流趋势，服务于关注娱乐新闻、追求时尚潮流的年轻及中年用户。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              我们相信，娱乐不只是消遣，更是一种观察世界的方式。因此我们坚持内容的时效性与多样性，既有适合快速浏览的热点速览，也产出值得深度阅读的报道与策划。
            </p>
            <div className="mt-6 flex flex-wrap gap-6">
              <div>
                <div className="text-3xl font-bold text-primary-600">{allArticles.length}+</div>
                <div className="mt-1 text-sm text-foreground-500">精选资讯</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent-600">4</div>
                <div className="mt-1 text-sm text-foreground-500">内容分类</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-secondary-700">每日</div>
                <div className="mt-1 text-sm text-foreground-500">持续更新</div>
              </div>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20creative%20media%20newsroom%20workspace%20with%20warm%20lighting%20and%20screens%2C%20editorial%20team%20atmosphere%2C%20orange%20and%20cream%20tones%2C%20high%20detail&width=1000&height=800&seq=about-hero-2026&orientation=landscape"
              alt="色哟哟编辑团队工作场景"
              title="色哟哟 - 多元娱乐资讯平台"
              className="h-72 w-full object-cover object-top md:h-[400px]"
            />
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">平台特色</h2>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <div key={f.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 py-10 md:px-8 md:py-14">
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">我们的团队</h2>
        <p className="mt-2 text-sm text-foreground-500">一群热爱娱乐内容、也认真对待内容的人。</p>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {team.map((m) => (
            <div key={m.name} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
              <div className="mx-auto h-20 w-20 overflow-hidden rounded-full bg-background-200">
                <img
                  src={m.avatar}
                  alt={m.name}
                  title={`${m.name} - 色哟哟编辑团队`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">{m.name}</h3>
              <span className="mt-1 inline-block rounded-full bg-accent-100 px-3 py-0.5 text-xs font-medium text-accent-700">
                {m.role}
              </span>
              <p className="mt-3 text-sm text-foreground-500">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-500">欢迎通过以下方式与我们取得联系。</p>
            <ul className="mt-6 space-y-4">
              <li className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">邮箱</div>
                  <div className="text-sm text-foreground-500">hello@seyoyo.example.com</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-line text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">办公地址</div>
                  <div className="text-sm text-foreground-500">上海市黄浦区创意园 A 座 12 层</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-time-line text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">工作时间</div>
                  <div className="text-sm text-foreground-500">周一至周五 09:30 - 18:30</div>
                </div>
              </li>
            </ul>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="text-base font-semibold text-foreground-900">网站使用说明与版权声明</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                本站内容仅供学习与演示用途，站内资讯、人物、时间等信息均为虚构，不代表任何真实事件或个人。转载或引用请注明出处。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                请合理使用本站服务，遵守相关法律法规。对于用户提交的内容，本站有权在必要时进行审核与调整。
              </p>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>

      <section className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col items-center justify-between gap-4 rounded-lg bg-primary-950 px-6 py-8 text-center md:flex-row md:text-left">
          <div>
            <h2 className="text-lg font-bold text-background-50 md:text-xl">准备好探索更多精彩内容了吗？</h2>
            <p className="mt-1 text-sm text-background-100/70">返回首页，看看今天有哪些新鲜资讯。</p>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
        </div>
      </section>
    </div>
  );
}